//
import * as React from 'react';
import PropTypes from 'prop-types';
import { css, color, StyleSheet, fontFamily } from "../../../styles/theme";
import TunnelVisionClose from "./TunnelVisionClose";
var styles = StyleSheet.create({
  TunnelVisionHeader: {
    borderBottom: "1px solid ".concat(color.border),
    display: 'flex',
    flexWrap: 'nowrap'
  },
  headerContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontFamily: fontFamily.body,
    margin: 0
  }
});
var TunnelVisionHeader = function TunnelVisionHeader(_ref) {
  var handleClose = _ref.handleClose,
    closeElement = _ref.closeElement,
    headerElement = _ref.headerElement,
    _ref$showCloseTooltip = _ref.showCloseTooltip,
    showCloseTooltip = _ref$showCloseTooltip === void 0 ? false : _ref$showCloseTooltip,
    backbuttonAriaLabel = _ref.backbuttonAriaLabel,
    closeButtonAlignment = _ref.closeButtonAlignment;
  var closeBtnProps = {
    closeElement: closeElement,
    handleClose: handleClose,
    showTooltip: showCloseTooltip,
    backbuttonAriaLabel: backbuttonAriaLabel,
    closeButtonAlignment: closeButtonAlignment
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "rc-TunnelVisionHeader ".concat(css(styles.TunnelVisionHeader).className, " ")
  }, closeButtonAlignment !== 'right' && /*#__PURE__*/React.createElement(TunnelVisionClose, closeBtnProps), /*#__PURE__*/React.createElement("div", css(styles.headerContainer), headerElement), closeButtonAlignment === 'right' && /*#__PURE__*/React.createElement(TunnelVisionClose, closeBtnProps));
};
TunnelVisionHeader.propTypes = {
  headerElement: PropTypes.element,
  closeElement: PropTypes.element,
  handleClose: PropTypes.func,
  showCloseTooltip: PropTypes.bool,
  backbuttonAriaLabel: PropTypes.string,
  closeButtonAlignment: PropTypes.string
};
export default TunnelVisionHeader;